import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class LocalStorageService {
	constructor() {}

	public remove(key: string): void {
		window.localStorage.removeItem(key);
	}

	public set(key: string, value: string) {
		window.localStorage.setItem(key, value);
	}

	public get(key: string) {
		return window.localStorage.getItem(key);
	}
}
